export const GenericNotificationID = 'generic-automation-notification';
export const HighPriorityAutomationNotificationID = 'high-priority-automation-notification';
export const ShoppingCartAbandonedNotificationID = 'abandoned-shopping-cart-notification';
export const HotLeadsNotificationID = 'hot-lead-notifications';
